import * as Yup from 'yup';

const personAssociateSchema = Yup.object({
  ptsAssociateID: Yup.number().nullable().required('Associate is required'),
  Relationship: Yup.string().nullable().required('Relationship is required'),
});

export default personAssociateSchema;
